// libraries
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

// assets
import { ImageHero, IconHabi } from "@assets";

// styles
import { BodyWrapper } from "./styles";

// components
import { AutoLoginLoader } from "./components";
import { ButtonGoogle } from "@shared/GoogleLoginButton/ButtonLoginGoogle";

// store
import { useAuthMutation } from "@store/apiSlices/auth/auth";
import {
  setUserProfile,
  setCountries,
  setCountry,
} from "@shared/GoogleLoginButton/user-slice/userSlice";

// utils
import {
  getAutoLoginData,
  clearAutoLoginParams,
  saveAutoLoginData,
} from "@shared/GoogleLoginButton/user-slice/auto-login";

// routes
import { pathHome } from "@routes/routes.types";
import { pathHomeReleaseNotes } from "@pages/HomePage/routes/routes.types";

export const LoginPageSSO = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [triggerAuth] = useAuthMutation();
  const [isAutoLoggingIn, setIsAutoLoggingIn] = useState(false);

  const authKey = process.env.ENV_AUTH_GOOGLE_API_KEY;

  useEffect(() => {
    const autoLoginData = getAutoLoginData();

    if (!autoLoginData) return;

    setIsAutoLoggingIn(true);
    saveAutoLoginData(autoLoginData);

    fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
      headers: {
        Authorization: `Bearer ${autoLoginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((profile) => {
        dispatch(
          setUserProfile({
            email: profile.email,
            familyName: profile.family_name,
            givenName: profile.given_name,
            googleId: profile.sub,
            imageUrl: profile.picture,
            name: profile.name,
          }),
        );

        return triggerAuth({ userId: profile.sub }).unwrap();
      })
      .then((cognitoData) => {
        dispatch(setCountries(cognitoData.countriesSelect));

        const activeCountry = cognitoData.countriesByUser[0];
        if (activeCountry) {
          dispatch(setCountry(activeCountry));
        }

        clearAutoLoginParams();
        navigate(`${pathHome}/${pathHomeReleaseNotes}`);
      })
      .catch(() => {
        clearAutoLoginParams();
        setIsAutoLoggingIn(false);
      });
  }, [dispatch, navigate, triggerAuth]);

  return (
    <>
      <div className="d-flex">
        <ImageHero style={{ height: "100vh" }} />
        <div className="d-flex align-items-center justify-content-center w-100">
          {isAutoLoggingIn ? (
            <AutoLoginLoader
              title="Iniciando sesión automáticamente..."
              subtitle="Verificando credenciales desde HWS Console"
            />
          ) : (
            <div>
              <div className="d-flex justify-content-center mb-5">
                <IconHabi />
              </div>

              <BodyWrapper className="d-flex flex-column gap-2 align-items-center justify-content-center">
                <div className="first-subtitle">
                  Aprobologos y aprobación de publicación
                </div>
                <h1 className="second-subtitle text-center">
                  Inicia sesión con tu <br /> cuenta Google
                </h1>
                {authKey ? (
                  <GoogleOAuthProvider clientId={authKey}>
                    <ButtonGoogle />
                  </GoogleOAuthProvider>
                ) : (
                  <div className="text-danger">
                    No se ha encontrado la clave de autenticación
                  </div>
                )}
              </BodyWrapper>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
